import React, { useEffect,useState } from "react";
import { MuiAppbar2 } from "../stories/appbar2";
import { GetUser } from "./../utils/sessions";
import { MenuContext } from "./../module/portal/menu-context";
import { useHistory } from "react-router-dom";
export default function LayoutMenu({ children, ScreenName }) {
  const { MenuList, GetMenuList, ScreenList } = React.useContext(MenuContext);
  const [ showContent, setShowContent ] = useState(true);
  const history = useHistory();
  useEffect(() => {
    GetMenuList();
  }, [GetMenuList]);

  const filterScreen = () => {
    // console.log(ScreenList);
    // console.log(ScreenName);
    if (ScreenList?.length > 0) {
      let obj = ScreenList.find(o => o.MODULE_NAME === ScreenName);
      if (!obj) {
        //console.log("zxc");
       setShowContent(false);
       history.push("/");
      }
    }
  }



  return (
    <>
      {/* {console.log(GetUser())}
    {console.log(ScreenName)}
    {console.log(MenuList)} */}
      {filterScreen()}


      <MuiAppbar2
        user={GetUser()}
        ScreenList={MenuList}
        ScreenName={ScreenName}
      >
        <>
          <section name="body">{(ScreenList?.length > 0 && showContent) ? children: ""}</section>
          <section name="footer"></section>
        </>
      </MuiAppbar2>
    </>
  );
}
